export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pptx.worker.3c5d3299.worker.js");
}
